import { render, staticRenderFns } from "./MediaTypeBadge.vue?vue&type=template&id=bb611e1c&scoped=true&"
import script from "./MediaTypeBadge.vue?vue&type=script&lang=js&"
export * from "./MediaTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./MediaTypeBadge.vue?vue&type=style&index=0&id=bb611e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb611e1c",
  null
  
)

export default component.exports